import type { WidgetConfig } from "@lifi/widget";

/**
 * LI.FI Widget theme configuration matching Cede Hub design system
 */
export const LIFI_WIDGET_THEME: WidgetConfig["theme"] = {
  palette: {
    primary: {
      main: "#1e5a94", // cede-button-primary
      light: "#2568a8", // cede-button-primary-hover
      dark: "#174a7a", // cede-button-primary-active
    },
    secondary: {
      main: "#5ea6ff", // cede-primary (for accents/links)
      light: "#9acfed",
      dark: "#1e5a94",
    },
    background: {
      default: "transparent",
      paper: "#1a2836",
    },
    text: {
      primary: "#ffffff",
      secondary: "#d1d5db",
    },
    success: { main: "#11cb81" },
    warning: { main: "#ffa726" },
    error: { main: "#f5465d" },
    grey: {
      200: "rgba(255, 255, 255, 0.08)",
      300: "rgba(255, 255, 255, 0.16)",
      700: "#6b7280",
      800: "#1f2937",
    },
  },
  shape: {
    borderRadius: 12,
    borderRadiusSecondary: 12,
    borderRadiusTertiary: 8,
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  container: {
    borderRadius: "16px",
    boxShadow: "none",
    border: "0",
  },
  components: {
    MuiCard: {
      defaultProps: { variant: "filled" },
    },
    MuiButton: {
      styleOverrides: {
        root: { color: "#ffffff !important" },
        textPrimary: { color: "#ffffff !important" },
        text: { color: "#ffffff !important" },
      },
    },
  },
};

/**
 * Default bridge configuration
 * Prefills Arbitrum USDT → Base USDT (high liquidity, low fees)
 */
export const DEFAULT_BRIDGE_CONFIG = {
  fromChain: 42161, // Arbitrum One
  fromToken: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9", // USDT on Arbitrum
  toChain: 8453, // Base
  toToken: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2", // USDT on Base
} as const;
